<div class="modal-header">
  <h3 class="p-0 m-0 text-white">
    {{ modalTitle | translate }}
  </h3>
  <button
    (click)="activeModal.close(false)"
    class="btn bg-transparent outline-none border-none px-0"
    type="button"
  >
    <img
      alt="Moidal close icon"
      src="./assets/media/svg/closeIcon.svg"
      width="20px"
    />
  </button>
</div>

<div class="modal-body mt-5 fs-3">
  @if (warningMessage) {
    <app-warning-massage [warningMessage]="warningMessage" />
  }
  @if (message) {
    {{ message | translate }}
  }
</div>
@if (hasFooter) {
  <div class="modal-footer gap-3">
    <app-cab-button
      (btnClick)="activeModal.close(true)"
      [label]="confirmText"
      [styleType]="btnStyleType"
    />

    <app-cab-button
      (btnClick)="activeModal.close(false)"
      [label]="cancelText"
      styleType="light"
    />
  </div>
}
